import React from 'react'
import Clock from '/components/clock'

export default \
class Screensaver extends React.Component
  render: ->
    <section className="Screensaver">
      <Clock />
    </section>
